import { IPoint } from "./IPoint";

export class Point {
  constructor(public x: number = 0, public y: number = 0) { }

  // TypeScriptでは演算子のオーバーロードはサポートされてない.
  add(difference: Point): Point {
    return new Point(
      this.x + difference.x,
      this.y + difference.y);
  }

  addValue(x: number, y: number): Point {
    return new Point(
      this.x + x,
      this.y + y);
  }

  subtract(difference: Point): Point {
    return this.add(difference.reverse());
  }

  multiply(multiplier: number) {
    return new Point(
      this.x * multiplier,
      this.y * multiplier);
  }

  reverse(): Point {
    return this.multiply(-1);
  }

  floor(): Point {
    return new Point(
      Math.floor(this.x),
      Math.floor(this.y),
    );
  }

  clone(): Point {
    return new Point(
      this.x,
      this.y
    );
  }

  static from(source: IPoint): Point {
    if (!source) {
      return null;
    }
    return new Point(source.x, source.y);
  }

  static to(source: Point): IPoint {
    if (!source) {
      return null;
    }
    return {
      x: source.x,
      y: source.y,
    };
  }
}
